<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else>

            <Timesheet
                v-if="showInnerTimeSheet"
                :timesheet-info="timesheet"
                :is-employee=true
            >
            </Timesheet>
            <div
                class="box-offset"
                v-else
            >
                <div class="box-ttl-wrap">
                    <div class="box-ttl ">
                        Time Sheet
                    </div>
                </div>
                <div class="buttons--row justify-content-end mb-4">
                    <div class="filter-wrap">
                        <label for="" class="reg-label mr-2">Filter:</label>
                        <div class="form-group form-group-2 mb-0">
                            <select
                                class="custom-select"
                                v-model="filters.filter"
                                @change="getListOfPeriods(filters)"
                            >
                                <option value="all" selected="">Select One</option>
                                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                            </select>
                        </div>
                    </div>
                    <button class="btn btn--primary btn--middle"
                            @click="showCustomModal('video', 1)">What is a timesheet?
                    </button>

                    <VideoModal
                        :modal-id="getCustomModalId('video',1)"
                    ></VideoModal>

                </div>
                <div class="table-holder table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>
                                <nobr>
                                    Two Week Payroll Period
                                </nobr>
                            </th>
                            <th>
                                <nobr>Timesheet Due Date</nobr>
                            </th>
                            <th>
                                Status
                            </th>
                            <th class="text-right pr-3">
                                Actions
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            class="clickable-row"
                            v-for="period in periods"
                            :key="period.id"
                        >
                            <td @click="showTimeSheet(period)">
                                <b>{{ dateForTimeSheets(period.start_date) }} - {{
                                        dateForTimeSheets(period.end_date)
                                    }}</b>
                            </td>
                            <td>
                                {{ calculateDeadlineForTimesheet(period.end_date) }}
                            </td>
                            <td>
                                <div v-if="period.timesheets[0].isSubmitted">
                                    Submitted
                                </div>
                                <div class="color--red" v-else>
                                    Not submitted
                                </div>
                            </td>
                            <td class="">
                                <div class="action-block" v-if="period.timesheets[0].isSubmitted">
                                    <div
                                        v-if="period.timesheets[0].file_id"
                                        class="text-center"
                                    >
                                        <a :href="`/uploads/${period.timesheets[0].file.file_path}`"
                                           class="color--secondary"
                                           title="View"
                                           target="_blank"
                                           v-if="period.timesheets[0].file_id"
                                        ><img src="/img/svg/icons-download.svg" alt="">
                                        </a>
                                    </div>
                                    <div v-else>
                                        <button
                                            class="btn btn--secondary btn--middle"
                                            @click="showTimeSheet(period)"
                                        >View
                                        </button>
                                    </div>
                                </div>
                                <div class="action-block" v-else>
                                    <button
                                        class="btn btn--secondary btn--middle"
                                        @click="showCustomModal('confirm', period.id)"
                                    >Submit
                                    </button>
                                    <ActionModal confirm-text="Yes" reject-text="No"
                                                 :modalId="getCustomModalId('confirm',period.id)"
                                                 @confirm="submitTimesheet(period)">
                                        <template #body>
                                            <div class="text-center mb-4">
                                                <h4>
                                                    Are you sure you want <br> to submit this timesheet?
                                                </h4>
                                            </div>
                                        </template>
                                    </ActionModal>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <Pagination
                    :currentPage="pagination.current_page"
                    :lastPage="pagination.last_page"
                    @changeItemsPerPage="changeItemsPerPage"
                    @changePage="changePage"/>
            </div>
        </div>
    </div>


</template>

<script>
import TimeSheetService from "../../../../TimeSheet/resources/js/services/TimeSheetService";
import PaginationHandler from "../../../../../../resources/js/mixins/PaginationHandler";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import Timesheet from "../../../../TimeSheet/resources/js/Timesheet.vue";
import ActionModal from "../../../../../../resources/js/components/ActionModal.vue";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import VideoModal from "../../../../../../resources/js/components/VideoModal.vue";

export default {
    name: 'EmployeeTimeSheet',
    components: {VideoModal, ActionModal, Timesheet},
    props: {
        userInfo: {
            type: Object
        },
    },
    mixins: [PaginationHandler, DateConverter, ModalHandler],
    data() {
        return {
            loading: true,
            showInnerTimeSheet: false,
            timesheet: {},
            selectedYear: new Date().getFullYear(),
            startYear: 2023,
            periods: [],
            filters: {
                filter: 'all',
                page: 1,
                perPage: 10,
                applicant_id: this.userInfo.id,
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },

        }
    },
    computed: {
        years() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let year = this.startYear; year <= currentYear; year++) {
                years.push(year);
            }
            return years;
        }
    },
    methods: {
        async getListOfPeriods() {
            try {
                const {data: response} = await TimeSheetService.getEmployeeListOfPeriods(this.filters)
                this.periods = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
            } catch (e) {
                console.error(e)
            }
        },
        getTimesheetInfo(periodInfo) {
            const period = {start_date: periodInfo.start_date, end_date: periodInfo.end_date, id: periodInfo.id};
            const applicant = {name: this.userInfo.name, last_name: this.userInfo.last_name}
            if (periodInfo.timesheets.length > 0) {
                const firstTimesheet = periodInfo.timesheets[0];
                this.timesheet = {...firstTimesheet};
            }
            this.timesheet = {
                ...this.timesheet,
                period: period,
                applicant: applicant,
            }
        },
        showTimeSheet(period) {
            if (period.timesheets[0].file_id) {
                return
            } else {
                this.getTimesheetInfo(period)
                this.showInnerTimeSheet = true;
            }
        },
        async submitTimesheet(period) {
            this.$showLoadingMessage()
            this.getTimesheetInfo(period)
            try {
                await TimeSheetService.submitTimesheetByEmployee(period.id, this.timesheet.id)
                this.$showSuccessMessage('Your timesheet has been submitted!')
                setTimeout(() => {
                    this.reloadPage()
                })
            } catch (e) {
                this.$showErrorMessage('Your timesheet was not submitted. Please try again')
            }
        }
    },
    mounted() {
        this.getListOfPeriods()
    }
}

</script>


<style scoped>

</style>
